import React from 'react'
import {Link} from 'react-router-dom'
import {Credential, Http} from 'common'
import {
    Window, LinkToRoot, PhoneHint,
    Form, Input, AuthPage
} from 'common/components'


export default class PasswordRecovery extends AuthPage {
    config = {
        namespace: 'recover',
        url: 'api/users/password/recovery',

        sanitize: ({login, _csrf}) => (
            {
                login: {
                    login: login,
                    loginType: Credential.typeOf(login)
                },
                _csrf
            }
        ),

        typeOf: ({login}) => (
            Credential.typeOf(login)
        ),

        redirect: ({login}) => (
            Credential.typeOf(login) === 'phone' ?
                `/passwordrecovery/${Credential.sanitize(login)}/confirm` : '/'
        )
    }

    heading = [
        'ВІДНОВЛЕННЯ ПАРОЛЯ',
        'Вкажіть телефон або пошту, на які бажаете отримати інструкцію по створенню нового пароля'
    ]


    render() {

        return (
            <Window message={this.heading} picture='password'>
                <div>
                    <Form
                        label='Відновити пароль'
                        className='auth__form-adaptive'
                        onSubmit={this.onSubmit}
                        csrf
                        captcha
                    >
                        <Input
                            name='login'
                            type='credential'
                            title='Телефон або пошта'
                            hint={() => (<PhoneHint/>)}
                        />
                    </Form>

                    <LinkToRoot />
                </div>
            </Window>
        )
    }
}

